import { AxiosError, AxiosResponse } from 'axios';
import {
  OMS_GET_OFFLINE_DOWNLOAD_FILE_PATH,
  OMS_OFFLINE_DOWNLOADS_PATH,
} from '../../constants/paths';
import {
  IOfflineDownloadListRequest,
  IOfflineDownloadListResponse,
  IOfflineDownloadRequest,
} from '../../models/downloads';
import { openFile, parseBlob } from '../../utils/http-helper';
import { apiB2B } from '../axios-client';
import { getUserId } from '../../utils/user';

const userId = getUserId() ?? '';

export const GetDownloadsList = (
  requestData: IOfflineDownloadListRequest,
  setDownloadsData: (data: IOfflineDownloadListResponse) => void,
  setDownloadsError: (error: AxiosError) => void,
  setDownloadsLoaded: (flag: boolean) => void,
) => {
  apiB2B
    .post(OMS_OFFLINE_DOWNLOADS_PATH(userId), requestData)
    .then((response: AxiosResponse<IOfflineDownloadListResponse>) =>
      setDownloadsData(response.data),
    )
    .catch((error: AxiosError) => setDownloadsError(error))
    .finally(() => setDownloadsLoaded(true));
};

export const GetSelectedDownloadFile = (
  requestData: IOfflineDownloadRequest,
  fileName: string,
) => {
  apiB2B
    .post(OMS_GET_OFFLINE_DOWNLOAD_FILE_PATH(userId), requestData)
    .then((response: AxiosResponse<string>) => {
      const blob = parseBlob(response.data, 'data:application/csv');
      openFile(blob, fileName);
    })
    .catch((error: AxiosError) => {
      return error;
    });
};
